class HeaderScroll {

  constructor(el, opt) {
    this.el = el;
    if (document.querySelector(this.el)) {
      this.event();
    }
  }
  event() {
    const Header = document.querySelector(this.el);
    const HeaderLogo = document.querySelector('.js-header__logo');
    const HeaderMenu = document.querySelector('.js-header__menu');

    const mm = gsap.matchMedia();

    const timeline = gsap.timeline({
      scrollTrigger: {
        trigger: 'body',
        start: 'top -=300px',
        end: 'top -=700px',
        scrub: 0.5
      }
    });

    mm.add('(min-width:769px)',()=>{
      timeline.to(Header, {
        backgroundColor: 'white',
        height: '6.6rem',
        paddingRight: '0',
      })
      .to(HeaderLogo, {
        width: '35rem',
      }, 0) 
      .to(HeaderMenu, {
        borderRadius: 0,
      }, 0);
    })
  }
}